import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  getActiveAreaId,
  getPatients,
  getPatientsExcelReport,
  getReceptionStatus,
} from "../../../../api/area";
import AddPatientIcon from "../../../../assets/SVG/addPatientIcon";
import notReception from "../../../../assets/image/notReception.png";
import SearchInput from "../../../project/searchInput";
import TablePatient from "../../table/tablePatient";
import ReceptionPop from "./receptionPop";
import { Loader } from "@/components/loader";
import EditReceptionModal from "./editReceptionModal";

export default function Reception() {
  const refBox = useRef();
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [dataRowEdit, setDataRowEdit] = useState();

  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [ageType, setAgeType] = useState();
  const [dataPatients, setDataPatients] = useState();
  const [loading, setLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState("");
  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalSize, setTotalSize] = useState();
  const [lastFetch, setLastFetch] = useState();

  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
    // setDate();
  };

  const [areaId, setAreaId] = useState();
  const [stopReceptionStatus, setStopReceptionStatus] = useState();
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [validValueSearch, setValidValueSearch] = useState();
  const md = useMediaQuery("(max-width:450px)");

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const fetchPatients = useCallback(() => {
    if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;

    const query = new URLSearchParams();
    query.append("pageIndex", pageable.pageIndex);
    query.append("pageSize", pageable.pageSize);

    if (validValueSearch && validValueSearch.length > 2) {
      query.append("search", validValueSearch);
    }
    query.append("needTotalElements", totalSize === undefined);
    setDataPatients([]);
    setLoading(true);
    getPatients(areaId, query.toString())
      .then((res) => {
        setDataPatients(res.patients);
        setLastFetch(Date.now());
        if (totalSize === undefined) setTotalSize(res.totalElements);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [areaId, pageable, validValueSearch, totalSize]);

  const getReceptionStatusLocal = useCallback(() => {
    getReceptionStatus(areaId)
      .then((res) => {
        setStopReceptionStatus(res);
      })
      .catch();
  }, [areaId]);

  useEffect(() => {
    if (areaId) {
      fetchPatients();
      getReceptionStatusLocal();
    }
  }, [areaId, pageable, validValueSearch]);

  const [timer, setTimer] = useState();

  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (
      valueSearch.length >= 3 ||
      (valueSearch.length === 0 && validValueSearch !== undefined)
    ) {
      const timer = setTimeout(() => {
        setValidValueSearch(valueSearch.length >= 3 ? valueSearch : undefined);
        setPageable({
          pageIndex: 0,
          pageSize: pageable.pageSize,
        });
        setTotalSize(undefined);
      }, 500);

      setTimer(timer);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <>
      {showEditModal && (
        <EditReceptionModal
          data={dataRowEdit}
          onClose={() => setShowEditModal(false)}
          areaId={areaId}
          onEdit={(newData) => {
            setDataPatients(
              dataPatients.map((e) => {
                if (e.patientInfo.id === newData.id) e.patientInfo = newData;
                return e;
              }),
            );
          }}
        />
      )}
      {showAddPatient && (
        <ReceptionPop
          onClose={() => setShowAddPatient(false)}
          ageType={ageType}
          areaId={areaId}
          onAdd={(newData) => {
            setDataPatients([newData, ...dataPatients]);
          }}
          onEdit={(newData) =>
            setDataPatients(
              dataPatients.map((e) => {
                if (e.patientInfo.id === newData.id) e.patientInfo = newData;
                return e;
              }),
            )
          }
        />
      )}
      {!showAddPatient && !showEditModal && (
        <Box>
          <Popover
            sx={{
              "& .MuiPaper-root": {
                width: "100px",
                height: "65px",
                padding: "15px 10px",
                borderRadius: "13px",
                bgcolor: "#B3BBBC",
              },
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box textAlign={"center"}>
              <Typography
                onClick={(e) => {
                  setAnchorEl(null);
                  setShowAddPatient(true);
                  setAgeType("ADULT");
                }}
                sx={{ cursor: "pointer" }}
                fontWeight={"bold"}
              >
                بزرگسالان
              </Typography>
              <Typography
                onClick={(e) => {
                  setAnchorEl(null);
                  setShowAddPatient(true);
                  setAgeType("CHILD");
                }}
                mt="15px"
                sx={{ cursor: "pointer" }}
                fontWeight={"bold"}
              >
                کودکان
              </Typography>
            </Box>
          </Popover>

          <Grid
            display={"flex"}
            flexDirection={md ? "column-reverse" : "row"}
            justifyContent={"space-between"}
            rowGap={"10px"}
          >
            <Grid display={"flex"} flexDirection={"row"}>
              <SearchInput
                type="text"
                id="filter-text-box-before-train"
                value={valueSearch}
                onChange={(e) => setValueSearch(e.target.value)}
                mb="5px"
              />
              {valueSearch.length >= 2 && (
                <Button
                  onClick={() => {
                    setValueSearch("");
                    setValidValueSearch(undefined);
                    setTotalSize(undefined);
                    setPageable({
                      pageIndex: 0,
                      pageSize: pageable.pageSize,
                    });
                  }}
                >
                  پاک کردن فیلتر
                </Button>
              )}
            </Grid>
            <Grid display={"flex"} flexDirection={"row"} gap={"30px"}>
              <Button
                disabled={loadingExcel}
                variant="outlined"
                onClick={() => {
                  setLoadingExcel(true);
                  const query = new URLSearchParams();
                  if (valueSearch && valueSearch.length > 1) {
                    query.append("searchKey", valueSearch);
                  }
                  getPatientsExcelReport(areaId, query)
                    .then((x) => {
                      const blob = new Blob([x], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `patients.xlsx`;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(url);
                      setLoadingExcel(false);
                    })
                    .catch(() => {
                      setLoadingExcel(false);
                    });
                }}
              >
                خروجی اکسل
              </Button>
              {!stopReceptionStatus && (
                <Box
                  display={"flex"}
                  sx={{ cursor: "pointer" }}
                  width="fit-content"
                  alignItems="center"
                  gap="10px"
                  ref={refBox}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                  <AddPatientIcon />
                  <Typography fontWeight="bold" color="var(--emr-primary)">
                    بیمار جدید
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>

          {loading && <Loader />}

          {!dataPatients?.length > 0 && (
            <Box display="flex" alignItems="center" justifyContent="center">
              <img src={notReception} style={{ marginTop: "50px" }} />
            </Box>
          )}

          {dataPatients?.length > 0 && (
            <TablePatient
              setDataRowEdit={setDataRowEdit}
              setShowEditModal={setShowEditModal}
              refetching={loading}
              areaId={areaId}
              rowData={dataPatients}
              setDataPatients={setDataPatients}
              pageable={pageable}
              totalElements={totalSize}
              setPageable={setPageable}
            />
          )}
        </Box>
      )}
    </>
  );
}
